import React from "react";
import ReactDOM from "react-dom/client";
import { Provider } from "react-redux";
import { BrowserRouter as Router } from "react-router-dom";
import store from "./redux/store";
import "bootstrap-icons/font/bootstrap-icons.css";

/**
 * Import service worker file
 */
import * as serviceWorkerRegistration from "./serviceWorkerRegistration";

/**
 * Import root Component - App
 */
import App from "./components/App";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <Router>
    <React.StrictMode>
      <Provider store={store}>
        <App />
      </Provider>
    </React.StrictMode>
  </Router>
);

serviceWorkerRegistration.unregister();
